



















import { Component, Vue } from "vue-property-decorator";
import { BaseModule } from "@/store/base.module";

@Component({
  name: "AppNotification",
})
export default class extends Vue {
  get snackBarPayload() {
    return BaseModule.snackBarPayload;
  }
}
